import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "userDashboard px-4" }
const _hoisted_2 = { class: "top0 wasteTimeline" }
const _hoisted_3 = { class: "pt-2" }
const _hoisted_4 = {
  key: 0,
  class: "text-justify text-base"
}
const _hoisted_5 = {
  key: 1,
  class: "text-justify text-base"
}
const _hoisted_6 = {
  key: 2,
  class: "text-justify text-base"
}
const _hoisted_7 = { class: "mt-4 p-float-label error-label" }
const _hoisted_8 = { for: "address" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_plus" }, null, -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { style: {"color":"red"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:inline" }, " - ", -1)
const _hoisted_13 = { class: "block md:inline" }
const _hoisted_14 = {
  key: 0,
  class: "px-1 sm:px-3 py-1 border-round-2xl flex align-items-center gap-2 text-500 mt-2 sm:mt-0 flex-shrink-0"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_bell_full" }, null, -1)
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = {
  key: 1,
  class: "bg-white px-3 py-1 border-round-2xl flex align-items-center gap-2 mt-2 sm:mt-0"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_bell_full text-primary" }, null, -1)
const _hoisted_19 = { class: "text-sm" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_plus" }, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "flex flex-column sm:flex-row bg-white border-round-md p-3 gap-3 sm:align-items-center"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_bell_full text-primary border-1 border-circle border-dashed border-primary p-3 inline-block" })
], -1)
const _hoisted_23 = { class: "flex flex-column" }
const _hoisted_24 = { class: "ml-auto" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_edit" }, null, -1)
const _hoisted_26 = {
  key: 1,
  class: "flex flex-column bg-white border-round-md p-3 gap-3"
}
const _hoisted_27 = { class: "flex flex-column gap-1" }
const _hoisted_28 = { class: "font-bold text-base" }
const _hoisted_29 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_30 = { class: "checkbox flex flex-column sm:flex-row gap-2" }
const _hoisted_31 = { class: "flex flex-column gap-1" }
const _hoisted_32 = { class: "font-bold text-base" }
const _hoisted_33 = { class: "mt-2 p-float-label error-label" }
const _hoisted_34 = { for: "time" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "flex justify-content-end align-items-center gap-4" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "flex flex-column mt-4 pb-2" }
const _hoisted_39 = { class: "mb-2" }
const _hoisted_40 = { class: "flex flex-column pt-2" }
const _hoisted_41 = { class: "flex gap-4 sm:gap-8" }
const _hoisted_42 = { class: "flex gap-1 flex-column sm:flex-row w-6rem sm:w-8rem mr-2" }
const _hoisted_43 = { class: "text-500" }
const _hoisted_44 = { class: "flex gap-2 md:gap-4 md:row-gap-2 flex-wrap" }
const _hoisted_45 = { class: "ml-1" }
const _hoisted_46 = { class: "mt-6 flex justify-content-end text-600 text-base" }
const _hoisted_47 = { class: "fillDialogTitle" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "fillDialogButtons" }
const _hoisted_50 = { class: "fillDialogTitle" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 2 }
const _hoisted_54 = { key: 3 }
const _hoisted_55 = { class: "fillDialogButtons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isOldWasteRedirect)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t("my_waste.private.timeline_description_new")), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("my_waste.private.timeline_description")), 1)),
          (_ctx.isOldWasteRedirect)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.$t("my_waste.private.backward_compability_info")) + " ", 1),
                _createVNode(_component_router_link, { to: { name: 'MyWaste' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("my_waste.private.here")), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_7, [
            _createVNode(_component_GMapAutocomplete, {
              class: _normalizeClass({
              'autocomplete pac-target-input': !_ctx.local,
              'autocomplete pac-target-input p-filled': _ctx.local,
            }),
              onPlace_changed: _ctx.setAddress,
              "select-first-on-enter": true,
              options: {
              bounds: {
                north: _ctx.center.lat + 0.2,
                south: _ctx.center.lat - 0.2,
                east: _ctx.center.lng + 0.2,
                west: _ctx.center.lng - 0.2,
              },
              strictBounds: true,
              componentRestrictions: { country: 'si' },
            },
              value: _ctx.local,
              id: "address",
              maxlength: "255",
              placeholder: ""
            }, null, 8, ["class", "onPlace_changed", "options", "value"]),
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("waste.waste_search")), 1),
            (_ctx.local !== null && _ctx.searchResult?.formatted_address)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "flex gap-2 absolute right-0 top-0 bg-primary border-none py-2 px-3 border-round-2xl shadow-2 cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkFoundAddress && _ctx.checkFoundAddress(...args)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t("my_waste.private.add_address")) + " ", 1),
                  _hoisted_9
                ]))
              : _createCommentVNode("", true),
            (_ctx.addressError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.addressError), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_Accordion, {
          "active-index": _ctx.selectedSubscriberIndex,
          "onUpdate:activeIndex": _ctx.openSubscriberCard,
          "expand-icon": "pi pi-angle-down",
          "collapse-icon": "pi pi-angle-up"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscribers, (subscriber, index) => {
              return (_openBlock(), _createBlock(_component_AccordionTab, {
                key: subscriber.id
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-full mr-4 flex flex-column md:flex-row md:align-items-center text-900", {
                'md:justify-content-between': index !== _ctx.selectedSubscriberIndex,
              }])
                  }, [
                    _createElementVNode("span", null, [
                      _createElementVNode("strong", null, _toDisplayString(subscriber.address.street) + " " + _toDisplayString(subscriber.address.house_number) + ", " + _toDisplayString(subscriber.address.city), 1),
                      _hoisted_12,
                      _createElementVNode("span", _hoisted_13, _toDisplayString(subscriber.local_community.title), 1)
                    ]),
                    (
                  index !== _ctx.selectedSubscriberIndex &&
                  !_ctx.isNotificationsActive(subscriber)
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("my_waste.private.inactive")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (
                  index !== _ctx.selectedSubscriberIndex &&
                  _ctx.isNotificationsActive(subscriber)
                )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("my_waste.private.active")), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (
                  index === _ctx.selectedSubscriberIndex &&
                  !_ctx.isNotificationsActive(subscriber)
                )
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "flex gap-2 bg-primary border-none py-2 px-3 border-round-2xl shadow-2 cursor-pointer sm:ml-3 mt-3 sm:mt-0 align-items-center flex-shrink-0",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectedSubscriber.showSettings = true), ["prevent","stop"]))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.$t("my_waste.private.activate")) + " ", 1),
                          _hoisted_20
                        ]))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                default: _withCtx(() => [
                  (
              !_ctx.selectedSubscriber.showSettings &&
              _ctx.isNotificationsActive(subscriber)
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("my_waste.private.notifications_active")), 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("my_waste.private.active_notification_time")) + " " + _toDisplayString(_ctx.selectedSubscriber.time), 1)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("button", {
                            class: "flex align-items-center gap-2 border-none bg-transparent text-600 cursor-pointer",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedSubscriber.showSettings = true))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("my_waste.private.edit")), 1),
                            _hoisted_25
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
              _ctx.selectedSubscriberIndex !== undefined &&
              _ctx.selectedSubscriber.showSettings
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("my_waste.private.channels.description")), 1),
                          (!_ctx.user.phone_number)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                _createTextVNode(_toDisplayString(_ctx.$t("my_waste.sms_disabled")) + " ", 1),
                                _createVNode(_component_router_link, { to: { name: 'MyProfile' } }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("user.my_profile")), 1)
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode(". ")
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex gap-3 align-items-center justify-content-between border-1 border-gray-300 p-2 border-round-md w-full sm:w-3 text-base", {
                    'bg-primary': _ctx.selectedSubscriber.sms,
                    'bg-gray-300': !_ctx.user.phone_number,
                  }])
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("my_waste.private.channels.sms")), 1),
                              _createVNode(_component_Checkbox, {
                                disabled: !_ctx.user.phone_number,
                                modelValue: _ctx.selectedSubscriber.sms,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedSubscriber.sms) = $event)),
                                binary: true,
                                onChange: _ctx.logfirebaseEvent
                              }, null, 8, ["disabled", "modelValue", "onChange"])
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex gap-3 align-items-center justify-content-between border-1 border-gray-300 p-2 border-round-md w-full sm:w-4 text-base", { 'bg-primary': _ctx.selectedSubscriber.push }])
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("my_waste.private.channels.push")), 1),
                              _createVNode(_component_Checkbox, {
                                modelValue: _ctx.selectedSubscriber.push,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedSubscriber.push) = $event)),
                                binary: true,
                                onChange: _ctx.logfirebaseEvent
                              }, null, 8, ["modelValue", "onChange"])
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex gap-3 align-items-center justify-content-between border-1 border-gray-300 p-2 border-round-md w-full sm:w-4 text-base", { 'bg-primary': _ctx.selectedSubscriber.email }])
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("my_waste.private.channels.email")), 1),
                              _createVNode(_component_Checkbox, {
                                modelValue: _ctx.selectedSubscriber.email,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedSubscriber.email) = $event)),
                                binary: true,
                                onChange: _ctx.logfirebaseEvent
                              }, null, 8, ["modelValue", "onChange"])
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("my_waste.private.notification_note")), 1),
                          _createElementVNode("span", _hoisted_33, [
                            _createVNode(_component_Calendar, {
                              modelValue: _ctx.selectedSubscriber.time,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedSubscriber.time) = $event)),
                              inputId: "time",
                              timeOnly: true,
                              hourFormat: "24"
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("my_waste.private.notification_hour")), 1),
                            (_ctx.errors.time !== '')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.errors.time), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("button", {
                            class: "border-none text-primary bg-transparent cursor-pointer",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.cancelNotificationSettings && _ctx.cancelNotificationSettings(...args)))
                          }, _toDisplayString(_ctx.$t("global.cancel")), 1),
                          _createElementVNode("button", {
                            "event-name": "wastePrivateWasteAcceptButtonClick",
                            "event-from": "/user/my-private-waste/timeline",
                            class: "flex gap-2 bg-primary border-none py-2 px-3 border-round-3xl shadow-2 cursor-pointer",
                            onClick: ($event: any) => (_ctx.updateNotifications(subscriber))
                          }, _toDisplayString(_ctx.$t("waste_notification.save")), 9, _hoisted_37)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("my_waste.private.schedule")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSubscriber.collections, (collections, date, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: date,
                        class: "flex flex-column"
                      }, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$moment(date, "DD.MM.YYYY").format("dddd")), 1),
                              _createElementVNode("span", _hoisted_43, _toDisplayString(date), 1)
                            ]),
                            _createElementVNode("div", _hoisted_44, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collections, (collection) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: collection.id
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["icon text-900", [
                          _ctx.getTrashcanValue(collection.waste_type, 'icon'),
                          _ctx.getTrashcanValue(collection.waste_type, 'name'),
                        ]])
                                  }, null, 2),
                                  _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.getTrashcanValue(collection.waste_type, "title")), 1)
                                ]))
                              }), 128))
                            ])
                          ]),
                          (
                    index !==
                    Object.keys(_ctx.selectedSubscriber.collections).length - 1
                  )
                            ? (_openBlock(), _createBlock(_component_Divider, { key: 0 }))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("span", {
                        tabindex: "0",
                        class: "cursor-pointer",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showDeleteDialog = true)),
                        onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.showDeleteDialog = true), ["enter"]))
                      }, _toDisplayString(_ctx.$t("my_waste.private.remove_address")), 33)
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["active-index", "onUpdate:activeIndex"])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showDeleteDialog,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showDeleteDialog) = $event)),
      class: "successDialog",
      tabindex: "1",
      closable: false,
      modal: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t("my_waste.private.delete_address")), 1),
        _createElementVNode("div", null, [
          (_ctx.selectedSubscriberIndex !== undefined)
            ? (_openBlock(), _createElementBlock("p", _hoisted_48, [
                _createTextVNode(_toDisplayString(_ctx.$t("my_waste.private.address")) + " ", 1),
                _createElementVNode("strong", null, _toDisplayString(_ctx.subscribers[_ctx.selectedSubscriberIndex].address.street) + " " + _toDisplayString(_ctx.subscribers[_ctx.selectedSubscriberIndex].address.house_number) + ", " + _toDisplayString(_ctx.subscribers[_ctx.selectedSubscriberIndex].address.city) + " " + _toDisplayString(_ctx.$t("my_waste.private.address_all")), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("my_waste.private.address_to_delete")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("button", {
            class: "defaultButton",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.removeSubscription(_ctx.selectedSubscriberIndex ?? 0))),
            tabindex: "1"
          }, _toDisplayString(_ctx.$t("my_waste.private.delete_confirm")), 1),
          _createElementVNode("span", {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showDeleteDialog = false)),
            tabindex: "1",
            onKeypress: _cache[12] || (_cache[12] = _withKeys(($event: any) => (_ctx.showDeleteDialog = false), ["enter"]))
          }, _toDisplayString(_ctx.$t("global.cancel")), 33)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.showFillDialog,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showFillDialog) = $event)),
      class: "successDialog",
      tabindex: "1",
      draggable: false,
      modal: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t("my_waste.fill_profile_address")), 1),
        _createElementVNode("div", null, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("my_waste.profile_address")) + ":", 1),
          (_ctx.user.contact_info && _ctx.user.contact_info.address)
            ? (_openBlock(), _createElementBlock("p", _hoisted_51, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("forms.application_forum.address")) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.user.contact_info.address), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.contact_info && _ctx.user.contact_info.house_number)
            ? (_openBlock(), _createElementBlock("p", _hoisted_52, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("forms.application_forum.house_number")) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.user.contact_info.house_number), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.contact_info && _ctx.user.contact_info.code)
            ? (_openBlock(), _createElementBlock("p", _hoisted_53, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("forms.application_forum.code")) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.user.contact_info.code), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.user.contact_info && _ctx.user.contact_info.city)
            ? (_openBlock(), _createElementBlock("p", _hoisted_54, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t("forms.application_forum.city")) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.user.contact_info.city), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("button", {
            class: "defaultButton",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.addUserAddress && _ctx.addUserAddress(...args))),
            tabindex: "1"
          }, _toDisplayString(_ctx.$t("my_waste.add_address")), 1),
          _createElementVNode("span", {
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showFillDialog = false)),
            tabindex: "1",
            onKeypress: _cache[16] || (_cache[16] = _withKeys(($event: any) => (_ctx.showFillDialog = false), ["enter"]))
          }, _toDisplayString(_ctx.$t("forms.application_forum.dialog.manual")), 33)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}